/**
 * Знак «Б» — логотип БРАСОЛ для свёрнутого бокового меню (каркас CRM v2).
 * Копия `frontend/src/layouts/BrasolMark.tsx` (импорт между пакетами запрещён):
 * глиф — первая буква словесного знака БРАСОЛ, подложка — фирменный индиго.
 */

/** Контур буквы «Б» в боксе 89.5 × 100 (нормализован из логотипа CRM). */
const GLYPH_B =
  "M79 0L79 0Q78.4 7.1 78.2 13.6Q78 20.2 78 23.7L78 23.7Q78 26.7 78.1 29.4Q78.2 32.1 78.4 33.9L78.4 33.9L75.1 33.9Q72.7 22.2 68.5 15.5Q64.3 8.8 59.3 6Q54.2 3.2 49.2 3.2L49.2 3.2L47.3 3.2Q43.6 3.2 41.8 3.9Q40 4.5 39.3 6.4Q38.7 8.2 38.7 12.1L38.7 12.1L38.7 40.4L43.9 40.4Q57.5 40.4 66.3 43.1Q75.1 45.8 80.2 50.1Q85.3 54.5 87.4 59.8Q89.5 65.1 89.5 70.5L89.5 70.5Q89.5 77 86.9 82.3Q84.3 87.7 79 91.7Q73.7 95.6 65.8 97.7Q57.9 99.9 47.2 99.9L47.2 99.9Q43.9 99.9 37.9 99.7Q31.8 99.6 23.4 99.6L23.4 99.6Q17.5 99.6 10.8 99.6Q4.1 99.7 0 100L0 100L0 97.2Q4.2 96.9 6.4 96Q8.6 95.2 9.3 92.7Q10 90.1 10 85L10 85L10 15Q10 9.7 9.3 7.3Q8.6 4.8 6.5 3.9Q4.4 3 0 2.8L0 2.8L0 0Q6.2 0.1 13.2 0.2Q20.2 0.3 27 0.4Q33.9 0.4 39.8 0.4L39.8 0.4L49.4 0.4Q55.9 0.4 64.2 0.4Q72.5 0.3 79 0ZM42.5 43.2L38.7 43.2L38.7 85Q38.7 89.7 39.3 92.3Q39.8 94.9 41.4 96Q42.9 97.2 45.9 97.2L45.9 97.2Q51.1 97.2 54.2 94.3Q57.2 91.4 58.5 85.6Q59.9 79.8 59.9 71.3L59.9 71.3Q59.9 63.7 58.5 57.3Q57.2 50.8 53.5 47Q49.9 43.2 42.5 43.2L42.5 43.2Z";

export function BrasolMark({ size = 36 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      focusable="false"
      className="fk-brand-badge"
    >
      <rect width="100" height="100" rx="22" fill="#251D4A" />
      {/* Высота буквы 56 % стороны, по центру квадрата. */}
      <path
        d={GLYPH_B}
        fill="#FFFFFF"
        transform="translate(24.9 22) scale(0.56)"
      />
    </svg>
  );
}
